'use strict';
import {createActions} from 'client/framework';

const normalActions = ['SET_SCHOOL_ID', 'SET_SELECTED_INTERVAL'];

export default createActions(null, normalActions);
